import { tv } from 'tailwind-variants';

const inputGroupClasses = tv({
  base: 'flex flex-col gap-sm relative transition-all w-full',
  variants: {
    variant: {
      sm: '',
      md: '',
      lg: '',
    },
    hasIconLeft: {
      true: '',
    },
    loading: {
      true: '',
    },
    hasError: {
      true: '',
    },
    disabled: {
      true: '',
    },
  },
});

const inputClasses = tv({
  base: 'dark:date-white rounded-md ring-0 text-mono-color-black border-hairline bg-mono-color-white border-nono-color-dark peer focus:ring-0 focus:border-brand-primary-pure focus:shadow-focused placeholder-transparent',
  variants: {
    variant: {
      sm: 'p-1 px-3 text-md',
      md: 'p-3 text-md',
      lg: 'p-4 text-lg',
    },
    hasIconLeft: {
      true: 'pl-11',
    },
    hasIconRight: {
      true: 'pr-11',
    },
    full: {
      true: 'w-full',
    },
    hasError: {
      true: 'border-feedback-color-error-pure focus:border-feedback-color-error-pure focus:shadow-error shadow-error',
    },
    disabled: {
      true: 'bg-mono-color-lighter text-mono-color-dark cursor-not-allowed focus:shadow-none border-mono-color-dark',
    },
  },
});

const labelClasses = tv({
  base: 'text-mono-color-black text-sm absolute bg-gradient-to-b from-color-transparent from-42.28% via-mono-color-white via-43.53% to-mono-color-white to-52.68% px-1 transition-all select-none pointer-events-none',
  variants: {
    variant: {
      sm: '',
      md: `
        left-3
        -top-2 
        peer-focus:-top-2
        peer-focus:text-sm      
        peer-placeholder-shown:text-md
        peer-placeholder-shown:top-3

    `,
      lg: `
        left-3
        -top-2

        peer-focus:-top-2
        peer-focus:text-sm
        peer-placeholder-shown:text-lg
        peer-placeholder-shown:top-3.5
      `,
    },
    hasIconLeft: {
      true: `
        left-3

        peer-focus:left-3
        peer-placeholder-shown:left-10
      `,
    },
    disabled: {
      true: 'text-mono-color-dark peer-placeholder-shown:bg-none',
    },
  },
});

const inputLeftIconClasses = tv({
  base: 'absolute left-3 h-6',
  variants: {
    variant: {
      sm: 'top-2',
      md: 'top-3',
      lg: 'top-4',
    },
    disabled: {
      true: 'fill-mono-color-dark',
    },
  },
});
const inputRightIconClasses = tv({
  base: 'absolute right-3 top-3 h-6',
  variants: {
    variant: {
      sm: 'top-2',
      md: 'top-3',
      lg: 'top-4',
    },
    disabled: {
      true: 'fill-mono-color-dark',
    },
  },
});

export const InputLoadingIcon = tv({
  base: 'absolute left-3 top-3 h-6 fill-none stroke-current animate-spin',
  variants: {
    variant: {
      sm: 'top-2',
      md: 'top-3',
      lg: 'top-4',
    },
    disabled: {
      true: 'stroke-mono-color-dark',
    },
  },
});

const helperTextClasses = tv({
  base: 'text-sm',
  variants: {
    variant: {
      sm: 'text-black',
      md: 'text-black',
    },
    disabled: {
      true: 'text-mono-color-dark',
    },
  },
});

const errorTextClasses = tv({
  base: 'text-sm text-feedback-color-error-pure',
  variants: {
    disabled: {
      true: 'text-mono-color-darkest',
    },
  },
});

export {
  errorTextClasses,
  helperTextClasses,
  inputClasses,
  inputGroupClasses,
  inputLeftIconClasses,
  inputRightIconClasses,
  labelClasses
};

